import React, { useState } from 'react'
import WidgetGroups from './user-login-edit/widget-group'
import WidgetNode from './user-login-edit/widget-node'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { UserLoginDetails } from './user-login-edit/user-details'
import { UserRoles } from './user-login-edit/user-roles'
import { UserInvite } from './user-login-edit/user-invite'
import { UserLinkedAccounts } from './user-login-edit/user-linked-accounts'
import { HeatmapLayoutUser } from '../../../../../view/heatmap/layout-user'
import { useParamsInt } from '../../../../../shared/hooks/location'
import { TileBody, TileColumn11112 } from '../../../../../shared/tile/tile-column-21111'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { IconEdit } from '../../../../../shared/icon/icon'
import { useApiFormUserLogin } from '../../../../../api-new/state/content'
import { HeaderMenu } from './common/header-menu'
import { Notice } from '../../../../../shared/sso-workspace/fleet-page'
import { ErrorReference } from '../../../../../shared/error/error-reference'
import { serverMessage } from '../../../../../shared/error/server-message'
import { useErrorLine } from '../../../../../shared/error/use-error-line'
import { RoleOrgGroup, RoleOrgGroupUser, RoleOrgNode, RoleOrgNodeUser } from '../../../../../role/components/role-org'

// Content answers 404 for the member's own read when they aren't a current
// member: removed (a member the partner API deactivated is one), or never
// one of this organization's.
export const NOT_A_CURRENT_MEMBER = "This person isn't a current member of this organization. If they were removed, you can restore them from the Users recycle bin."

export const UserLoginEdit = () => {
  const { userID } = useParamsInt()

  const apiFormUserLogin = useApiFormUserLogin()

  const [notMember, setNotMember] = useState(false)
  const [loadError, loadFailure, setLoadError] = useErrorLine()

  // api-new rejects with the response itself (a plain object), and this runs
  // from effects that nobody awaits: an uncaught rejection otherwise, which a
  // browser reports as "Uncaught (in promise) Object".
  const handlePath = async () => {
    try {
      await apiFormUserLogin.get(`${userID}`)
      setNotMember(false)
      setLoadError(null)
    } catch (err) {
      if (err && err.status === 404) {
        setNotMember(true)
        return setLoadError(null)
      }
      setNotMember(false)
      setLoadError(serverMessage(err, "This person couldn't be loaded."), err)
    }
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text={apiFormUserLogin.form.email} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormUserLogin.form.email} HeaderMenu={HeaderMenu}>
          {notMember && <Notice tone="warn" role="status">{NOT_A_CURRENT_MEMBER}</Notice>}
          {loadError && <Notice tone="bad" role="alert">{loadError}<ErrorReference error={loadFailure} /></Notice>}
          <TileBody>
            <TileColumn11112>
              {!notMember && <UserLoginDetails userLogin={apiFormUserLogin.form} />}
              {!notMember && <UserInvite userLogin={apiFormUserLogin.form} onUpdate={handlePath} />}
              <UserLinkedAccounts userID={userID} />
            </TileColumn11112>

            <TileColumn11112>
              {!notMember && <UserRoles userID={userID} />}

              <RoleOrgGroup accessRead>
                <RoleOrgGroupUser accessRead>
                  <WidgetGroups userID={userID} />
                </RoleOrgGroupUser>
              </RoleOrgGroup>

              <RoleOrgNode accessRead>
                <RoleOrgNodeUser accessRead>
                  <WidgetNode userID={userID} />
                </RoleOrgNodeUser>
              </RoleOrgNode>
            </TileColumn11112>
          </TileBody>
        </CardFullHeightScrollY>
      </BreadcrumbView>
      <HeatmapLayoutUser />
    </React.Fragment>
  )
}
